import { ProjectDictionary } from '../projects';
import * as Achievements from './achievements.interface';
import * as Collective from './collective.interface';
import * as Personal from './personal.interface';
import { UnionToIntersection } from '../common/union-to-intersection';
import { DateRange } from '../utils';

export type RequestOptions = DateRange;

type MappedPipelineData = {
  achievements: Achievements.Data;
  personal: Personal.Data;
  collective: Collective.Data;
};

// Prefix with some string because some .Data objects have the same keys
// e.g. collective.treesFunded & personal.treesFunded
export type PipelineData = UnionToIntersection<
  {
    [category in keyof MappedPipelineData]: {
      [index in keyof MappedPipelineData[category] as `${category}.${string &
        index}`]: MappedPipelineData[category][index];
    };
  }[keyof MappedPipelineData]
>;

export type CardType = keyof PipelineData;
export type CardData = { [index in CardType]: PipelineData[index] };

// first request, return all cards - some may be failed hence Partial<T>
export type InitialPayload = Partial<PipelineData> & {
  projectDictionary: ProjectDictionary;
};

// single card requested, return data & project dictionary
export type CardPayload<T extends CardType> = [data: CardData[T], projectDictionary: ProjectDictionary] | undefined; // undefined = failure state

export type ChartData<TLabels = number, KValues = number> = {
  labels: TLabels[]; // y axis
  values: KValues[]; // x axis
};
